import type { FunctionComponent } from 'preact'
import { WebsterIcon } from './WebsterIcon'

interface AIChatButtonProps {
  onClick: () => void
  hasNotification?: boolean
}

export const AIChatButton: FunctionComponent<AIChatButtonProps> = ({
  onClick,
  hasNotification = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="ai-chat-fab fixed bottom-6 right-6 w-20 h-20 rounded-full bg-slate-900 dark:bg-slate-800
                 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300
                 flex items-center justify-center z-[60] group overflow-visible"
      aria-label="Open Webster"
    >
      {/* Aware state – dimmed at rest, fades out on hover */}
      <WebsterIcon size={68} state="aware" className="webster-btn-aware" />
      {/* Thinking state – hidden at rest, fades in on hover with glow */}
      <WebsterIcon size={68} state="thinking" className="webster-btn-thinking" />

      {/* Notification Dot */}
      {hasNotification && (
        <span className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full border-2 border-white animate-pulse" />
      )}
    </button>
  )
}
